import {
  html,
  css,
  OmniElement,
  OmniStyleElement,
  OmniSwitchElement,
  OmniTileElement,
  OmniIconElement,
} from 'omni-ui';

import logoSvg from '../svgs/icon-omni-logo.js';

import './omni-app-container-auth-menu.js';
import './omni-app-container-client-selection-menu.js';

OmniIconElement.register();
OmniTileElement.register();
OmniSwitchElement.register();
OmniStyleElement.register();

export class OmniAppContainerHeader extends OmniElement {
  static get properties() {
    return {
      activeEnv: { type: String },
      activeClient: { type: String },
      profile: { type: Object },
      context: { type: Object },
      session: { type: Object },
    };
  }

  static get styles() {
    return [
      super.styles,
      css`
        .nav {
          height: 3.57rem;
          padding: 0 1.57rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;
        }

        .nav-left {
          display: flex;
        }

        .nav-divider {
          height: 1.64rem;
          margin: 0.965rem 2.2rem; /* match nav padding */
          width: 1px; /* in lieu of border beacuse it's empty */
          background: var(
            --color-pale-grey-three
          ); /* guessed closest for variable */
        }

        .logo-link {
          width: 5.57rem;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .logo-image {
          width: 100%;
        }

        .megadropdown {
          margin-right: 2.2rem;
        }

        .megadropdown,
        .megadropdown-trigger {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .omni .button.megadropdown-trigger-button {
          /* specificity battle */
          width: 2.5rem;
          height: 2.5rem;
          padding: 0;
        }

        .megadropdown-trigger-button omni-icon.all-tools-icon {
          width: 2.07rem;
          height: 2.07rem;
        }
        .omni .megadropdown-trigger-button.is-primary omni-icon.all-tools-icon {
          /* specificity battle */
          fill: var(--white);
        }

        .megadropdown-content {
          width: 100%;
          padding-bottom: 2rem;
        }

        .omni .megadropdown-content .columns {
          margin: 0;
        }

        .omni .megadropdown-content .column {
          position: relative;
          padding: 0;
        }

        .column:not(:last-child):after {
          content: '';
          display: block;
          position: absolute;
          right: -1px;
          width: 1px; /* emulate border */
          top: 2rem;
          bottom: 0;
          background: var(--color-pale-grey-three);
        }

        .column h4 {
          opacity: 0.4;
          font-size: 1rem;
          font-weight: 600;
          line-height: 1.143rem;
          letter-spacing: 0.02rem;
          color: var(--color-almost-black);
          height: 2.57rem;
          padding: 0.714rem 1.428rem;
        }
      `,
    ];
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('click', this._handleDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._handleDocumentClick);
    super.disconnectedCallback();
  }

  render() {
    return html`
      <omni-style>
        <div class="nav">
          <div class="nav-left">
            <span class="logo-link is-clickable">${logoSvg}</span>
            <div class="nav-divider"></div>
            <div class="megadropdown">
              <div class="megadropdown-trigger">
                <button
                  aria-label="All Tools Menu"
                  class="button is-text has-text-almost-black megadropdown-trigger-button"
                >
                  <omni-icon
                    class="all-tools-icon"
                    icon-id="omni:informative:tools"
                  ></omni-icon>
                </button>
              </div>
            </div>
            <omni-app-container-client-selection-menu
              .clients=${this.profile?.clients}
              .activeClient=${this.activeClient}
              .session=${this.session}
            ></omni-app-container-client-selection-menu>
          </div>
          <omni-app-container-auth-menu
            env=${this.activeEnv}
            .session=${this.session}
          ></omni-app-container-auth-menu>
        </div>
      </omni-style>
    `;
  }
}

OmniElement.register('omni-app-container-header', OmniAppContainerHeader);
